import { render, staticRenderFns } from "./familyList.vue?vue&type=template&id=38ff72ac&scoped=true"
import script from "./familyList.vue?vue&type=script&lang=js"
export * from "./familyList.vue?vue&type=script&lang=js"
import style0 from "./familyList.vue?vue&type=style&index=0&id=38ff72ac&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import style1 from "./familyList.vue?vue&type=style&index=1&id=38ff72ac&prod&lang=css"
import style2 from "./familyList.vue?vue&type=style&index=2&id=38ff72ac&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ff72ac",
  null
  
)

export default component.exports